/** @jsxImportSource theme-ui */
import { Container, Heading, Box, Flex } from 'theme-ui';
import CreateAction from '@/containers/incentives/CreateAction';

const CreateActionPage = () => {
    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Create Action
            </Heading>
            <CreateAction />
        </Container>
    );
};

export default CreateActionPage;
